import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Skeleton } from '@/components/ui/skeleton';

export const ProtectedRoute = ({ roles, children }) => {
  const { user, authLoading } = useApp();
  const loc = useLocation();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-background p-6" data-testid="auth-loading">
        <div className="max-w-5xl mx-auto space-y-4">
          <Skeleton className="h-10 w-64" />
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};
